import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import { handleListResponse, handleError } from '@/services/amio-api/utils/request-utils'
import merge from 'ramda/src/merge'

class ContactService {
  constructor() {
    this.path = '/channels'
  }

  get(channelId, contactId, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .get(`${this.path}/${channelId}/contacts/${contactId}`)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  list(channelId, params = {}, ignoredHttpStatuses = []) {
    const _params = merge({offset: 0, max: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(`${this.path}/${channelId}/contacts`, {
        params: _params
      })
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  delete(channelId, id, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .delete(`${this.path}/${channelId}/contacts/${id}`)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new ContactService()
